import { api } from "../utils/api";

export const deleteGuest = async (hotelId: number, guestId: number) => {
    const response = await api.post(`/api/v1/users/delete-guest/${hotelId}/`, {
      guest_id: guestId,
    });
    return response;
  };
  
  